import { Button, Card, DatePicker, Flex, Input, Select, Table, type TableProps, theme, Typography } from 'antd'
import dayjs from 'dayjs'
import { useState } from 'react'
import useMobileView from '@shared/hooks/isMobile'
import MobileButton from '@shared/ui/mobile-button/mobile-button'
import './styled.css'
import { colors } from '@app/providers/config-provider/lib/theme'

interface DataType {
    key: string
    date: string
    text: string
    sum: string
    status: string
}

export const Management = () => {
    const [isWithdrawMoney, setIsWithdrawMoney] = useState(false)
    const {
        token: { colorSuccess, colorWhite, colorBgLayout }
    } = theme.useToken()
    const isMobile = useMobileView()

    const columns: TableProps<DataType>['columns'] = [
        {
            title: 'Дата',
            dataIndex: 'date',
            key: 'date'
        },
        {
            title: 'Описание',
            dataIndex: 'text',
            key: 'text'
        },
        {
            title: 'Сумма',
            dataIndex: 'sum',
            key: 'sum'
        },
        {
            title: 'Статус',
            dataIndex: 'status',
            key: 'status',
            render: (text) => {
                return (
                    <Button
                        type={'primary'}
                        style={{ backgroundColor: colorSuccess, color: colorWhite, cursor: 'auto' }}
                    >
                        {text}
                    </Button>
                )
            }
        }
    ]

    const data: DataType[] = [
        // {
        //     key: '1',
        //     sum: '500',
        //     date: '23 декабря 2024, 19:54',
        //     status: 'Выполнено',
        //     text: 'Оплата продавцу'
        // },
        // {
        //     key: '2',
        //     sum: '500',
        //     date: '23 декабря 2024, 19:54',
        //     status: 'success',
        //     text: 'Оплата продавцу'
        // },
        // {
        //     key: '3',
        //     sum: '500',
        //     date: '23 декабря 2024, 19:54',
        //     status: 'success',
        //     text: 'Оплата продавцу DESIGN-LOGO за заказ Отрисовка логотипа по эскизу, картинке'
        // }
    ]
    if (isMobile) {
        return (
            <Flex vertical gap={'middle'}>
                {!isWithdrawMoney && (
                    <Card style={{ backgroundColor: '#FFFFFF', width: '100%' }}>
                        <Flex wrap={'nowrap'} gap={5} align={'center'}>
                            <Typography.Paragraph style={{ margin: 0, fontSize: 17 }}>Ваш баланс:</Typography.Paragraph>
                            <Typography.Title style={{ margin: 0, fontSize: 24 }}>0 ₽</Typography.Title>
                        </Flex>
                        <Flex vertical gap={10} style={{ marginTop: 20 }}>
                            <MobileButton> Использовать на подписку</MobileButton>
                            <MobileButton bg={'#63C930'} onClick={() => setIsWithdrawMoney(true)}>
                                {' '}
                                Вывести деньги
                            </MobileButton>
                        </Flex>
                    </Card>
                )}
                <Flex gap={'middle'}>
                    <DatePicker
                        showTime
                        showSecond={false}
                        style={{
                            width: 100,
                            backgroundColor: colorWhite,
                            border: 'none',
                            height: '50px',
                            fontSize: 17
                        }}
                        format={['DD/MM/YYYY HH:mm', 'DD/MM/YY HH:mm', 'DD.MM.YYYY HH:mm', 'DD.MM.YY HH:mm']}
                        minDate={dayjs()}
                        placeholder="от"
                    />
                    <DatePicker
                        showTime
                        showSecond={false}
                        style={{
                            width: 100,
                            backgroundColor: colorWhite,
                            border: 'none',
                            height: '50px',
                            fontSize: 17
                        }}
                        format={['DD/MM/YYYY HH:mm', 'DD/MM/YY HH:mm', 'DD.MM.YYYY HH:mm', 'DD.MM.YY HH:mm']}
                        minDate={dayjs()}
                        placeholder="до"
                    />
                </Flex>
                <Flex justify={'space-between'} gap={8}>
                    <Select
                        className={'management-select'}
                        placeholder={'Все операции'}
                        style={{ width: '100%', border: 'none', height: '50px', fontSize: 17 }}
                        options={[{ value: 'sample', label: <span>sample</span> }]}
                    />
                    <Select
                        className={'management-select'}
                        placeholder={'Название кворка'}
                        style={{ width: '100%', border: 'none', height: '50px', fontSize: 17 }}
                        options={[{ value: 'sample', label: <span>sample</span> }]}
                    />
                </Flex>
                {data.map((item) => {
                    return (
                        <Card style={{ backgroundColor: '#FFFFFF', width: '100%' }}>
                            <Flex justify={'space-between'} align={'center'}>
                                <Typography.Title style={{ color: '#021728', fontSize: 14, margin: 0 }}>
                                    {item.date}
                                </Typography.Title>
                                <Button style={{ backgroundColor: '#63C930', color: 'white', border: 'none' }}>
                                    {item.status}
                                </Button>
                            </Flex>

                            <Typography.Paragraph
                                style={{ color: '#8F8E94', marginTop: 21, marginBottom: 15, fontSize: 14 }}
                            >
                                {item.text}
                            </Typography.Paragraph>
                            <Typography.Paragraph
                                style={{ color: '#F41919', marginTop: 21, marginBottom: 0, fontSize: 14 }}
                            >
                                -{item.sum} ₽
                            </Typography.Paragraph>
                        </Card>
                    )
                })}
            </Flex>
        )
    }

    return (
        <Flex vertical gap={'middle'} style={{ maxHeight: 'calc(100vh - 380px)', overflow: 'auto' }}>
            {!isWithdrawMoney && (
                <Card style={{ backgroundColor: '#FBFAFB', width: 502 }}>
                    <Flex gap={'middle'} justify={'space-between'} align={'center'}>
                        <Typography.Title style={{ margin: 0, color: colors.lightTextColor }}>0 ₽</Typography.Title>
                        <Flex gap={'small'}>
                            <Button type={'primary'} style={{ backgroundColor: colorSuccess, color: colorWhite }}>
                                Использовать на подписку
                            </Button>
                            <Button
                                onClick={() => setIsWithdrawMoney(true)}
                                type={'default'}
                                style={{ backgroundColor: colorWhite, color: colorSuccess, borderColor: colorSuccess }}
                            >
                                Вывести деньги
                            </Button>
                        </Flex>
                    </Flex>
                </Card>
            )}
            {isWithdrawMoney && (
                <Card style={{ backgroundColor: '#FBFAFB', width: 970 }}>
                    <Flex gap={'middle'} wrap={'nowrap'} align={'center'}>
                        <Typography.Title style={{ margin: 0 }}>0 ₽</Typography.Title>
                        <Flex gap={'small'}>
                            <Select
                                className={'management-select'}
                                placeholder={'Все операции'}
                                style={{ width: 200 }}
                                options={[{ value: 'sample', label: <span>sample</span> }]}
                            />
                            <Input style={{ backgroundColor: colorWhite }} />
                            <Input style={{ width: 100, backgroundColor: colorWhite }} />
                            <Button type={'primary'} style={{ backgroundColor: colorSuccess, color: colorWhite }}>
                                Вывести
                            </Button>
                            <Button onClick={() => setIsWithdrawMoney(false)} type={'default'}>
                                Отменить
                            </Button>
                        </Flex>
                    </Flex>
                    <Typography.Text>
                        Комиссия платежной системы на вывод для вас составляет 7%, но не менее 33 руб. Выводить можно
                        суммы от 50 руб., но рекомендуется выводить суммы от 471 руб. и выше, чтобы комиссия была
                        минимальной.
                    </Typography.Text>
                </Card>
            )}
            <Flex gap={'middle'}>
                <DatePicker
                    showTime
                    showSecond={false}
                    style={{ width: 80, backgroundColor: colorBgLayout }}
                    format={['DD/MM/YYYY HH:mm', 'DD/MM/YY HH:mm', 'DD.MM.YYYY HH:mm', 'DD.MM.YY HH:mm']}
                    minDate={dayjs()}
                    placeholder="от"
                />
                <DatePicker
                    showTime
                    showSecond={false}
                    style={{ width: 80, backgroundColor: colorBgLayout }}
                    format={['DD/MM/YYYY HH:mm', 'DD/MM/YY HH:mm', 'DD.MM.YYYY HH:mm', 'DD.MM.YY HH:mm']}
                    minDate={dayjs()}
                    placeholder="до"
                />
                <Select
                    className={'management-select'}
                    placeholder={'Все операции'}
                    style={{ width: 200 }}
                    options={[{ value: 'sample', label: <span>sample</span> }]}
                />
                <Select
                    className={'management-select'}
                    placeholder={'Название кворка'}
                    style={{ width: 200 }}
                    options={[{ value: 'sample', label: <span>sample</span> }]}
                />
            </Flex>
            <Table<DataType> columns={columns} dataSource={data} />
        </Flex>
    )
}
